<tc-send-message-form
  (submitted)="onSubmit($event)"
  [mixpanelClickEvent]="mixpanelClickEvent"
  [hasInternal]="internal"
></tc-send-message-form>
